export default "__VITE_ASSET__bP5llzoW__"